import { render, staticRenderFns } from "./addSet.vue?vue&type=template&id=6404362e"
import script from "./addSet.vue?vue&type=script&lang=js"
export * from "./addSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports